import { render, staticRenderFns } from "./tra.vue?vue&type=template&id=7cfa3dde&scoped=true&"
import script from "./tra.vue?vue&type=script&lang=js&"
export * from "./tra.vue?vue&type=script&lang=js&"
import style0 from "./tra.vue?vue&type=style&index=0&id=7cfa3dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa3dde",
  null
  
)

export default component.exports